import { Box, Grid, useMediaQuery } from '@mui/material'
import React from 'react'
import { styled, useTheme } from '@mui/material/styles'
import { useSettings } from 'src/@core/hooks/useSettings'
import LoginImage from 'src/assets/Login-Container.png'
import AuthLanguageBar from './AuthLanguageBar'

const LeftWrapper = styled(Box)(({ theme }) => ({
  height: '100vh', // Full screen height
  display: 'flex',
  flex: 1
}))

const LeftContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100%',
  backgroundImage: `url(${LoginImage})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat'
}))

const RightWrapper = styled(Box)(({ theme }) => ({
  margin: 'auto',
  [theme.breakpoints.up('md')]: {
    maxWidth: 774
  }
}))

const AuthLayout = ({ children }) => {
  const theme = useTheme()
  const { settings } = useSettings()

  const { skin } = settings
  const hidden = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <>
      <AuthLanguageBar />
      <Grid container className='content-right' style={{ height: '100vh' }}>
      <Grid item xs={12} md={7}>
        <Box className='content-center'>
          <RightWrapper
            sx={skin === 'bordered' && !hidden ? { borderRight: `1px solid ${theme.palette.divider}` } : {}}
          >
            {hidden && (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
              // marginBottom="2.5rem"
              // marginTop="2.5rem"
              >
                {/* Logo can go here if needed */}
              </Box>
            )}
            {children}
          </RightWrapper>
        </Box>
      </Grid>
      {!hidden && (
        <Grid item xs={12} md={5}>
          <LeftWrapper>
            <LeftContainer />
          </LeftWrapper>
        </Grid>
      )}
    </Grid>
    </>
  )
}

export default AuthLayout
